module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('header', {
    staticClass: "view__header"
  }, [_c('h2', {
    staticClass: "view__title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('article', {
    staticClass: "view__content"
  }, [_c('div', {
    staticClass: "view__panel"
  }, [_c('submenu'), _vm._v(" "), (_vm.isDisabled) ? _c('div', {
    staticClass: "message message--warning"
  }, [_vm._v("\n        " + _vm._s(_vm.L.localize('Membership_PaymentOptions_CannotBeEdited_Content')) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('TextBox', {
    attrs: {
      "label": "Label_Name",
      "validate": _vm.$v.model,
      "modelPath": "name",
      "acc": "name",
      "disabled": _vm.isDisabled
    },
    on: {
      "input": _vm.$v.model.name.$touch
    },
    model: {
      value: (_vm.model.name),
      callback: function($$v) {
        _vm.$set(_vm.model, "name", $$v)
      },
      expression: "model.name"
    }
  }), _vm._v(" "), _c('TextBox', {
    attrs: {
      "label": "Label_Amount",
      "validate": _vm.$v.model,
      "modelPath": "amount",
      "type": "number",
      "min": 0,
      "max": 10000,
      "step": "0.01",
      "acc": "amount",
      "disabled": _vm.isDisabled
    },
    on: {
      "input": _vm.$v.model.amount.$touch
    },
    model: {
      value: (_vm.model.amount),
      callback: function($$v) {
        _vm.$set(_vm.model, "amount", $$v)
      },
      expression: "model.amount"
    }
  }), _vm._v(" "), _c('SelectList', {
    attrs: {
      "label": "Membership_PaymentOptions_RepeatsType",
      "disabled": _vm.isDisabled,
      "options": _vm.repeatsTypeOptions,
      "acc": "repeatstype"
    },
    model: {
      value: (_vm.model.repeatsType),
      callback: function($$v) {
        _vm.$set(_vm.model, "repeatsType", $$v)
      },
      expression: "model.repeatsType"
    }
  }), _vm._v(" "), (_vm.model.repeatsType == 3) ? _c('TextBox', {
    attrs: {
      "label": "Label_DurationInMonths",
      "validate": _vm.$v.model,
      "modelPath": "durationInMonths",
      "type": "number",
      "min": 1,
      "max": 10000,
      "step": "1",
      "acc": "durationInMonths",
      "disabled": _vm.isDisabled
    },
    on: {
      "input": _vm.$v.model.durationInMonths.$touch
    },
    model: {
      value: (_vm.model.durationInMonths),
      callback: function($$v) {
        _vm.$set(_vm.model, "durationInMonths", $$v)
      },
      expression: "model.durationInMonths"
    }
  }) : _vm._e(), _vm._v(" "), _c('Btn', {
    attrs: {
      "isLoading": _vm.loading,
      "label": "Label_SaveButton"
    },
    on: {
      "click": _vm.save
    }
  }), _vm._v(" "), _c('Btn', {
    attrs: {
      "label": "Label_CancelButton",
      "withBorder": true
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'payment-options'
        })
      }
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-044f550d!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/views/membership/payment-options/PaymentOption.vue
// module id = 700
// module chunks = 1